import { QuestionCircleOutlined } from '@ant-design/icons';
import { usePostFrontRichiesteIdCopia } from '@framework/api-client';
import { getNetworkErrorMessage } from '@framework/auth';
import { useTranslation } from '@framework/i18n';
import { useHistory } from '@framework/ui';
import { Button, Modal, message, theme } from 'antd';
import { ButtonProps } from 'antd/lib';
import { useCallback } from 'react';
import { redirectToSubmissionPage } from './principal-module-redirector/redirectToSubmissionPage';
const { useToken } = theme;

export interface ISubmissionCloneButtonProps extends ButtonProps {
  submissionId?: string | null;
  isJustCreated?: boolean;
  iconOnlyButton?: boolean;
}

/**
 * Pulsante per duplicare una richiesta lato FO
 */
export function SubmissionCloneButton(props: ISubmissionCloneButtonProps) {
  const { submissionId, iconOnlyButton, isJustCreated, ...otherProps } = props;
  const { token } = useToken();
  const history = useHistory();
  const clone = usePostFrontRichiesteIdCopia();
  const { t } = useTranslation();
  const [modal, contextHolder] = Modal.useModal();

  const handleClone = useCallback(() => {
    if (!submissionId) {
      message.error(t("submission-clone-button.la-richiesta-deve-essere-salvata-per-duplicare", `La richiesta deve essere salvata per poter essere duplicata.`)); // prettier-ignore
      return;
    }

    modal.confirm({
      title: t(
        'submission-clone-button.sei-sicuro-di-voler-duplicare-la-richiesta',
        'Sei sicuro di voler duplicare la richiesta?',
      ),
      content: t(
        'submission-clone-button.la-richiesta-verra-duplicata-senza-i-file-allegati',
        'La richiesta verrà duplicata senza i file allegati.',
      ),
      icon: (
        <QuestionCircleOutlined
          aria-hidden="true"
          style={{ color: token.colorPrimary }}
        />
      ),
      type: 'error',
      okText: t('submission-clone-button.duplica', 'Duplica'),
      cancelText: t('submission-clone-button.chiudi', 'Chiudi'),
      async onOk() {
        try {
          const clonedSubmissionId = await clone.mutateAsync({
            id: submissionId,
          });

          message.success(
            t(
              'submission-clone-button.richiesta-duplicata-con-successo',
              'Richiesta duplicata con successo.',
            ),
          );

          await redirectToSubmissionPage(clonedSubmissionId, history);
        } catch (e) {
          console.error(
            t(
              'submission-clone-button.errore-nel-duplicare-la-richiesta',
              `Errore nel duplicare la richiesta`,
            ),
            { e },
          );
          message.error(getNetworkErrorMessage(e, t("submission-clone-button.errore-durante-la-duplicazione-della-richiesta",`Si è verificato un errore durante la duplicazione della richiesta.`))); // prettier-ignore
        }
      },
      onCancel() {},
    });
  }, [token.colorPrimary, clone, submissionId, history, t, modal]);

  return (
    <>
      {contextHolder}
      <Button
        type="default"
        size="large"
        disabled={isJustCreated}
        onClick={() => handleClone()}
        {...otherProps}
      >
        {!iconOnlyButton && (
          <>
            {t(
              'submission-clone-button.duplica-richiesta',
              'Duplica la Richiesta',
            )}
          </>
        )}
      </Button>
    </>
  );
}
